module.exports = __webpack_public_path__ + "img/learn-2.8f96a9d9.png";